import AnimationClip from '../AnimationClip';
import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import { delay } from '../../../Utility/Task/TaskQueue';
import { MathHelper } from '../../../Utility/MathHelper';
import Point from '../../../Utility/Point';
import ToolboxItem from '../../../Prototype/UI/Level/ToolboxItem';
import { AwaitIterators, StartAnimation } from '../AnimationHelper';
import Renderable from '../../../Component/Renderable';
import ColorFilter from '../../../Component/ColorFilter';
import Interactable from '../../../Component/Interactable';

export class BoosterItemReveal extends AnimationClip {
    public *execute(
        gameObject: ToolboxItem,
        meta: any
    ): IterableIterator<number> {
        let duration: number = 700; // + (350 * Math.random());

        const gameObjectTransform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        gameObjectTransform.scale.set(0, 0);
        gameObject.getComponent(Renderable).visible = true;

        const p1 = gameObjectTransform.position.clone() as Point;
        const p4 = new Point(
            meta.offset.x + gameObjectTransform.position.x,
            meta.offset.y +
                gameObjectTransform.position.y -
                meta.index * meta.spacing
        );
        const p2 = new Point(
            (p1.x / 2 - p4.x / 2) * Math.random(),
            (p1.y / 2 - p4.y / 2) * Math.random()
        );
        const p3 = new Point(
            (p4.x / 2 - p1.x / 2) * Math.random(),
            (p4.y / 2 - p1.y / 2) * Math.random()
        );

        const scaleTween = this.getTween(gameObjectTransform.scale);
        scaleTween.to({ x: 1, y: 1 }, duration).easing(Easing.Quadratic.In);

        const bezierTween = this.getTween({ progress: 0 });
        bezierTween
            .to({ progress: 1 }, duration)
            .onUpdate(t => {
                const xy = MathHelper.cubicBezier(t.progress, p1, p2, p3, p4);
                gameObjectTransform.position.set(xy.x, xy.y);
            })
            .onComplete(() => {
                const colorFilter: ColorFilter = gameObject.getComponent(
                    ColorFilter
                );
                const interactable: Interactable = gameObject.getComponent(
                    Interactable
                );
                const renderable: Renderable = gameObject.getComponent<
                    Renderable
                >(Renderable);
                colorFilter.saturation = meta.visibility.saturation;
                interactable.enabled = meta.visibility.enabled;
                renderable.visible = meta.visibility.visible;
                meta.onComplete();
                StartAnimation(gameObject, 'BoosterDescriptionShow');
            });

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(bezierTween),
        ]);
        yield* delay(duration - 100);
    }
}
